import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import StudentForm from "./StudentForm";
import StudentBar from "./StudentBar";
import Reportcard from "./Reportcard";
import Schoolfee from "./Schoolfee";
import Reportcardnote from "./Reportcardnote";

class Profile extends Component {
  state = { student: { user: { user: {} } }, isModal: false, formData: {}, classe: false,
    reportlabels: [], reportdata: [], loading: true, error: "" };

  componentDidMount() { this.getUser(); }

  getStudentreports = async (userId) => {
    if (!userId) return;
    try {
      const response = await axios.get(`users/students/${userId}`);
      const reports = response.data?.students || [];
      this.setState({
        reportlabels: reports.map((report) => report.year?.year || ""),
        reportdata: reports.map((report) => report.studentmax > 0
          ? Number(((report.studentsuccess * 100) / report.studentmax).toFixed(1)) : 0),
      });
    } catch (error) { this.setState({ reportlabels: [], reportdata: [] }); }
  };

  getUser = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const response = await axios.get(`students/${this.props.match.params.studentId}`);
      const student = response.data || { user: { user: {} } };
      this.setState({ student, loading: false });
      this.getStudentreports(student.user?.id);
    } catch (error) {
      this.setState({ loading: false, error: error.response?.data?.msg || "Impossible de charger le profil de cet élève." });
    }
  };

  showModal = (student = null, classe = false) => {
    this.setState((state) => ({ isModal: !state.isModal, formData: student, classe: classe ? student : null }),
      () => { if (!this.state.isModal) this.getUser(); });
  };

  delete = (studentId) => {
    if (!window.confirm("Supprimer définitivement cet élève ?")) return;
    axios.delete(`students/${studentId}`).then((response) => {
      toast(response?.data?.msg || "Élève supprimé.", { theme: "light", style: { backgroundColor: "#157347", color: "white" } });
      this.props.history?.push("/students");
    }).catch((error) => toast(error.response?.data?.msg || "La suppression a échoué.",
      { theme: "light", style: { backgroundColor: "#dc3545", color: "white" } }));
  };

  handleCheck(permission) {
    try {
      const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
      return permissions.some((item) => permission === item.permission);
    } catch (error) { return false; }
  }

  renderContact(icon, value, href) {
    return <div className="student-profile-contact">
      <span className="student-profile-contact__icon"><FeatherIcon icon={icon} size={15} /></span>
      {href && value ? <a href={`${href}${value}`}>{value}</a> : <span>{value || "Non renseigné"}</span>}
    </div>;
  }

  render() {
    const { student, loading, error } = this.state;
    const user = student.user || {}, parent = user.user || {};
    const fullName = [user.last_name, user.family_name, user.first_name].filter(Boolean).join(" ");
    const parentName = [parent.first_name, parent.last_name].filter(Boolean).join(" ");
    const classe = student.sectionclass ? [student.sectionclass.class?.short_entitled_class,
      student.sectionclass.title, student.sectionclass.section?.short_entitled_section
        ? `# ${student.sectionclass.section.short_entitled_section}` : ""].filter(Boolean).join(" ") : "";
    const canEdit = this.handleCheck("Modifier élève"), canDelete = this.handleCheck("Supprimer élève");

    if (loading) return <main className="container ev-page student-profile-page"><div className="student-profile-state" role="status"><span className="spinner-border spinner-border-sm" />Chargement du profil…</div></main>;
    if (error) return <main className="container ev-page student-profile-page"><div className="student-profile-state is-error"><FeatherIcon icon="alert-circle" /><strong>{error}</strong><button className="btn btn-sm btn-outline-primary" onClick={this.getUser}>Réessayer</button></div></main>;

    return <main className="container ev-page student-profile-page">
      <header className="ev-page-header student-profile-header">
        <div className="ev-page-header__content">
          <span className="ev-page-header__eyebrow"><FeatherIcon icon="user" size={14} /> Dossier élève</span>
          <h1>{fullName || "Profil de l’élève"}</h1>
          <p>{student.matricule || "Sans matricule"}{classe ? ` · ${classe}` : ""}</p>
        </div>
        <div className="ev-page-header__actions">
          <Link to={`/studentfile/${this.props.match.params.studentId}`} className="btn btn-sm btn-primary student-profile-action"><FeatherIcon icon="file-text" size={15} />Fiche complète</Link>
          {canEdit && <button onClick={() => this.showModal(student)} className="btn btn-sm btn-outline-primary student-profile-action"><FeatherIcon icon="edit-3" size={15} />Modifier</button>}
        </div>
      </header>

      <section className="student-profile-identity">
        <div className="student-profile-identity__main">
          <div className="student-profile-avatar">{user.avatar ? <img src={user.avatar} alt={`Portrait de ${fullName}`} /> : <FeatherIcon icon="user" size={34} />}</div>
          <div><span className="student-profile-badge">Élève</span><h2>{fullName || "Nom non renseigné"}</h2><p>Année scolaire : <strong>{student.year?.year || "Non renseignée"}</strong></p></div>
        </div>
        <div className="student-profile-identity__meta">
          <div><small>Matricule</small><strong>{student.matricule || "—"}</strong></div>
          <div><small>N° ID</small><strong>{user.numberId || user.identity_number || "—"}</strong></div>
          <div><small>Classe actuelle</small><strong>{classe || "Non affecté"}</strong></div>
        </div>
      </section>

      <section className="ev-page-section student-profile-details">
        <div className="ev-page-section__header"><div><span className="student-profile-section-kicker">Coordonnées</span><h2>Informations de contact</h2></div></div>
        <div className="student-profile-contact-grid">
          <article><h3><FeatherIcon icon="user" size={16} /> Élève</h3>{this.renderContact("phone", user.tel, "tel:")}{this.renderContact("mail", user.email, "mailto:")}{this.renderContact("map-pin", user.adress)}</article>
          <article><h3><FeatherIcon icon="users" size={16} /> Responsable</h3>{this.renderContact("user", parentName)}{this.renderContact("phone", parent.tel, "tel:")}{this.renderContact("mail", parent.email, "mailto:")}{this.renderContact("map-pin", parent.adress)}</article>
        </div>
      </section>

      <div className="student-profile-columns">
        <div className="student-profile-column">
          <section className="ev-page-section student-profile-panel">
            <div className="ev-page-section__header"><div><span className="student-profile-section-kicker">Scolarité</span><h2>Parcours de l’élève</h2></div><FeatherIcon icon="book-open" /></div>
            {user.id && <Reportcard user={user.id} title="Parcours de l’élève" matricule={student.matricule} name={fullName} classe={classe} />}
          </section>
          {this.state.reportlabels.length > 0 && <section className="ev-page-section student-profile-panel">
            <div className="ev-page-section__header"><div><span className="student-profile-section-kicker">Progression</span><h2>Statistique du parcours</h2></div><FeatherIcon icon="bar-chart-2" /></div>
            <StudentBar data={this.state.reportdata} labels={this.state.reportlabels} title="Statistique parcours" matricule={student.matricule} name={fullName} classe={classe} />
          </section>}
        </div>
        <div className="student-profile-column">
          <section className="ev-page-section student-profile-panel">
            <div className="ev-page-section__header"><div><span className="student-profile-section-kicker">Finances</span><h2>Paiements de l’élève</h2></div><FeatherIcon icon="credit-card" /></div>
            {student.id && <Schoolfee user={student.id} title="Paiements de l’élève" matricule={student.matricule} name={fullName} classe={classe} />}
          </section>
          {student.id && <Reportcardnote student={student.id} category="Examen" title="examens" matricule={student.matricule} name={fullName} classe={classe} />}
          {student.id && <Reportcardnote student={student.id} category="Deuxieme session" title="deuxième session" matricule={student.matricule} name={fullName} classe={classe} />}
        </div>
      </div>
      {student.id && <Reportcardnote student={student.id} category="Cours" title="évaluations" matricule={student.matricule} name={fullName} classe={classe} />}
      {canDelete && <section className="student-profile-danger"><div><strong>Suppression du dossier</strong><span>Cette action retire définitivement l’élève.</span></div><button onClick={() => this.delete(student.id)} className="btn btn-sm btn-outline-danger student-profile-action"><FeatherIcon icon="trash-2" size={15} />Supprimer</button></section>}
      <StudentForm isModal={this.state.isModal} formData={this.state.formData} classe={this.state.classe} showModal={this.showModal} />
    </main>;
  }
}

export default Profile;
